import {Component, Injector, OnInit} from '@angular/core';
import {PomodoroRepository} from '../Models/PomodoroRepository';
import {Router} from '@angular/router';
import {UserService} from '../services/user.service';

@Component({
  selector: 'app-login-as',
  templateUrl: './login-as.component.html',
  styleUrls: ['./login-as.component.css']
})
export class LoginAsComponent implements OnInit {
  public token = '';
  public pomodoroRepository: PomodoroRepository;
  constructor(private injector: Injector,
              private router: Router,
              private userService: UserService) {
    this.pomodoroRepository = PomodoroRepository.getInstance(injector);
  }

  ngOnInit(): void {
  }
  setToken(): any{
    localStorage.setItem('token', this.token);
    this.userService.getCurrentUserInfo().subscribe((dd) => {
      localStorage.setItem('userId', dd.id);
      localStorage.setItem('userProfile', dd.profile_photo_url);
    });
    this.pomodoroRepository.userIsLoggedIn = true;
    this.router.navigateByUrl('/profile').then();
  }
}
